<template>
  <div class="filter-container">
    <vs-button color="secondary" type="border" class="h-full" @click="isShow = !isShow"><feather-icon icon="FilterIcon" style="width: 20px; height: 20px" class="align-bottom" /> 필터 </vs-button>
    <vx-card v-show="isShow" class="content" style="z-index: 1000">
      <!-- HEAD -->
      <div class="flex items-center justify-between">
        <p class="title">필터</p>
        <button class="none-style" @click="isShow = false"><feather-icon icon="XIcon" style="width: 20px; height: 20px" class="align-bottom" /></button>
      </div>
      <!-- BODY -->
      <div class="body flex flex-col gap-3 my-3">
        <fragment v-for="(filterData, filterData_i) in filterDataList">
          <div class="flex items-center gap-3 py-2" :key="`filterData_${filterData_i}`">

            <!-- label-->
            <p class="title">{{ `필터 ${filterData_i + 1}` }}</p>

            <!-- key -->
            <vs-select autocomplete v-model="filterData.key" style="width: 174px;" @change="(key) => onClickSelectKey(filterData_i)">
              <vs-select-item v-for="key in filterKeys" :key="key" :text="key" :value="key" />
            </vs-select>

            <!-- value -->
            <ml-input v-if="filterTypes[filterKeys.indexOf(filterData.key)] === 'input'"
                      class="flex-1" v-model="filterData.value"/>
            <multi-select v-else-if="filterTypes[filterKeys.indexOf(filterData.key)] === 'multi-select'"
                          class="flex-1" v-model="filterData.value" :options="getFilterValueOptions(filterData.key)" />

            <!-- delete -->
            <button class="trash-button" @click="deleteFilter(filterData_i)"><feather-icon icon="Trash2Icon" style="width: 20px; height: 20px; color: #7e72f2" class="align-bottom" /></button>
          </div>
        </fragment>
        <button v-if="enabledAddOption" style="color: #7e72f2" class="w-24 py-2 none-style" @click="addFilter"><feather-icon icon="PlusIcon" style="width: 20px; height: 20px" class="align-top mr-1" />필터 추가</button>
      </div>
      <!-- Foot -->
      <div class="flex justify-end gap-3">
        <vs-button color="secondary" type="border" @click="isShow = false"> 닫기 </vs-button>
        <vs-button color="secondary" type="border" @click="resetFilterDataList"> 초기화 </vs-button>
        <vs-button color="secondary" @click="finishFilter"> 적용 </vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import MultiSelect from "@/components/multi-select/MultiSelect.vue";
import vueMultiselect from 'vue-multiselect';

export default {
  name: 'FilterModule',
  components: {vueMultiselect, MultiSelect},
  props: {
    filterKeys: {
      type: Array,
      default: () => [],
    },
    filterTypes: {
      type: Array,
      default: () => [],
    },
    filterValueOptions: Object,
    value: {
      type: Array,
      default: () => [],
    },
    // 필터 추가 버튼 활성화 여부 (true 일 경우, "추가" 버튼이 표시됨)
    enabledAddOption: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShow: false,
      filterDataList: [],
      test: [],
    };
  },
  watch: {
    isShow() {
      if (this.isShow) this.resetFilterDataList();
      else this.filterDataList = []
    },
    value: {
      handler(value) {
        if (value.length === 0) this.resetFilterDataList();
        else this.filterDataList = JSON.parse(JSON.stringify(value));
      },
    },
  },
  methods: {
    addFilter() {
      this.filterDataList.push({
        key: this.filterKeys && this.filterKeys.length > 0 ? this.filterKeys[0] : '',
        value: ["전체"] });
    },
    deleteFilter(index) {
      if (this.filterDataList.length > 1) {
        this.filterDataList.splice(index, 1);
      } else {
        this.filterDataList = [];
      }
    },
    resetFilterDataList() {
      this.filterDataList = JSON.parse(JSON.stringify(this.value));
    },
    finishFilter() {
      this.isShow = false;
      this.$emit("input", JSON.parse(JSON.stringify(this.filterDataList)));
      this.filterDataList = [];
    },
    onClickSelectKey (index) {
      const filterData = this.filterDataList[index]
      if (this.filterTypes[this.filterKeys.indexOf(filterData.key)] === 'input') {
        filterData.value = (typeof filterData.value === 'string') ? filterData.value : ''
      } else if (this.filterTypes[this.filterKeys.indexOf(filterData.key)] === 'multi-select') {
        const options = this.getFilterValueOptions(filterData.key)
        let isReset = true
        for (const option of options) {
          if (filterData.value.includes(option)) {
            isReset = false
            break
          }
        }
        if (isReset) {
          filterData.value = ['전체']
        }
      }
    },
    getFilterValueOptions (key) {
      if (this.filterValueOptions) {
        return ['전체', ...this.filterValueOptions[key]]
      }

      return ['전체']
    }
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  position: relative;
  min-width: 110px;
  height: 38px;

  & > .content {
    position: absolute;
    top: calc(100% + 56px);
    left: 0;
    z-index: 100;

    width: 695px;

    .title {
      font-size: 17px;
      font-weight: 500;
    }
    .body {
      padding: 7px 17px;
      border-width: 1px 0px 1px 0px;
      border-style: solid;
      border-color: #7e72f20d;
    }

    button.none-style {
      cursor: pointer;
      background: none;
      border: none;
    }
  }
}
</style>
